import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const PROVIDER_TYPES_ENDPOINT = "/provider-type";

export class ProviderTypeService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE TIPOS DE PROVEEDORES
     * @EN GETS THE LIST OF PROVIDER TYPES
     */
    // -------------------------------------------------------------------------------------------------------------
    listProviderTypes = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN TIPO DE PROVEEDOR POR SU ID
     * @EN GETS A PROVIDER TYPE BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getProviderTypeById = async (providerTypeId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/get",
            data: { id: providerTypeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN TIPO DE PROVEEDOR
     * @EN CREATES A PROVIDER TYPE
     */
    // -------------------------------------------------------------------------------------------------------------
    createProviderType = async (providerType: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/create",
            data: providerType,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN TIPO DE PROVEEDOR
     * @EN EDITS A PROVIDER TYPE
     */
    // -------------------------------------------------------------------------------------------------------------
    editProviderType = async (providerType: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/edit",
            data: providerType,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN TIPO DE PROVEEDOR
     * @EN DELETES A PROVIDER TYPE
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteProviderType = async (providerTypeId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/delete",
            data: { id: providerTypeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS TIPOS DE PROVEEDORES
     * @EN DELETES MULTIPLE PROVIDER TYPES
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiProviderType = async (providerTypeIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/delete-multi",
            data: { 
                ids:providerTypeIds
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE TIPOS DE PROVEEDORES PARA UN SELECT
     * @EN GETS THE LIST OF PROVIDER TYPES FOR A SELECT
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDER_TYPES_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}